<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <div class="logo">
      <img alt="Microtronics Logo" src="@/assets/mt_logo.svg" width="100%">
    </div>
    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
      <sidenav-divider/>
      <sidenav-menu iconfa="heartbeat" :open="true">
        <div slot="link-text">Event Monitoring</div>
        <sidenav-router-link to="/" :exact="true">Home</sidenav-router-link>
        <sidenav-link href="#" icon="">Physical</sidenav-link>
        <sidenav-link href="#" icon="">Software</sidenav-link>
        <sidenav-link href="#" icon="">Communication</sidenav-link>
      </sidenav-menu>
      <sidenav-divider/>
      <sidenav-router-link to="/customers" iconfa="user-tie" :exact="true">Customers</sidenav-router-link>
      <sidenav-divider/>
      <sidenav-router-link to="/aloha" iconfa="hand-spock" :exact="true">Aloha</sidenav-router-link>
      <sidenav-divider/>
      <sidenav-router-link to="/users" iconfa="users" :exact="true">Users</sidenav-router-link>
      <sidenav-divider/>
      <sidenav-router-link to="/notifications" iconfa="comment" :exact="true">Notifications</sidenav-router-link>
      <sidenav-divider/>
      <sidenav-router-link to="/statistics" iconfa="chart-pie" :exact="true">Statistics</sidenav-router-link>
      <sidenav-divider/>
      <sidenav-router-link to="/sites" iconfa="project-diagram" :exact="true">Sites</sidenav-router-link>
      <sidenav-divider/>
      <sidenav-router-link to="/devices" iconfa="tablet-alt" :exact="true">Devices</sidenav-router-link>

    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>

<style scoped>
  .logo {
    background: var(--yellow);
    height: 70px;
    padding: 0 1.75rem;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-flex: 0;
    flex-grow: 0;
    flex-shrink: 0;
    line-height: 1;
  }
</style>
